import { render, staticRenderFns } from "./Case.vue?vue&type=template&id=b94bf37e&scoped=true"
import script from "./Case.vue?vue&type=script&lang=js"
export * from "./Case.vue?vue&type=script&lang=js"
import style0 from "./Case.vue?vue&type=style&index=0&id=b94bf37e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94bf37e",
  null
  
)

export default component.exports